exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inquiry-table[data-v-33af7eda]{margin-top:16px}.pagination[data-v-33af7eda]{margin-top:12px;text-align:right}[data-v-33af7eda] .el-table__body td{padding:8px 0 !important;height:40px !important}\n", ""]);

// exports
